/**
 * Teachers Carousel
 * Initializes Glide.js carousel for teacher cards
 */

if (typeof window.Glide !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('.teachers-carousel-glide');

    carousels.forEach(function (carousel) {
      const slideCount = carousel.querySelectorAll('.glide__slide').length;

      // Only initialize if there are slides
      if (slideCount > 0) {
        const glide = new Glide(carousel, {
          type: 'slider',
          startAt: 0,
          perView: 4,
          gap: 0,
          swipeThreshold: false,
          peek: {
            before: 0,
            after: 30,
          },
          breakpoints: {
            1024: {
              perView: 3,
              peek: {
                before: 0,
                after: 20,
              },
            },
            749: {
              perView: 2,
              peek: {
                before: 0,
                after: 15,
              },
            },
          },
        });

        // Mount the carousel
        glide.mount();
      }
    });
  });
} else {
  // Fallback if Glide.js hasn't loaded
  console.warn('Glide.js is not loaded. Teachers Carousel will not be initialized.');
}
